// extracted by mini-css-extract-plugin
export default {"bannerContainer":"_3A8TG","bannerImage":"_1d7-o","bannerContent":"UUfrL","bannerContentWithText":"_1LWkz","description":"vqSTl","onlyDescription":"xDiFs","title":"yczFW"};